import React from 'react';
import PropTypes from 'prop-types';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import MenuItem from '@material-ui/core/MenuItem';
import Spinner from '@/modules/common/components/Spinner';
import ButtonMenu from '@/modules/common/components/ButtonMenu';

const DownloadMenu = (props) => {
    return (
        <PopupState variant="popover">
            {(popupState) => (
                <ButtonMenu buttonProps={{disabled: props.fetching, ...bindTrigger(popupState)}}
                            buttonContent={<>
                                Загрузить
                                {(props.fetching) ? <Spinner/> : null }
                            </>}
                            menuProps={{...bindMenu(popupState)}}
                >
                    <MenuItem onClick={props.onClickDownload(popupState, 'csv')}>
                        Загрузить CSV
                    </MenuItem>
                    <MenuItem onClick={props.onClickDownload(popupState, 'xlsx')}>
                        Загрузить XLSX
                    </MenuItem>
                </ButtonMenu>
            )}
        </PopupState>
    );
};

DownloadMenu.propTypes = {
    fetching: PropTypes.bool.isRequired,
    onClickDownload: PropTypes.func.isRequired,
};

export default DownloadMenu;
